export const environment = {
  production: true,
  idCia: 1,
  gateway: '/gateway/mktp-services',
  host: 'https://gw.americanasmarketplace.com.br',
  oldHost: 'https://portal.americanasmarketplace.com.br',
  site: 'https://americanasmarketplace.com.br',
};
